var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "background-image-configuration" },
    [
      _c(
        "div",
        { staticClass: "search-form" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "name", $$v)
                      },
                      expression: "searchForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.query } },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.list, border: "" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  selectable: _vm.checkSelectable,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "名称", width: "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "imageUrl", label: "图片", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.getImageUrl(scope.row.imageUrl)
                          ? _c("img", {
                              staticClass: "table-image",
                              attrs: {
                                src: _vm.getImageUrl(scope.row.imageUrl),
                                alt: "背景图",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "type", label: "类型", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 0
                          ? _c("el-tag", [_vm._v("默认")])
                          : scope.row.type === 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("门店"),
                            ])
                          : scope.row.type === 2
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("城市"),
                            ])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "门店/城市", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 1
                          ? _c(
                              "span",
                              [
                                _vm.getStoreNames(scope.row.shopids).length > 20
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: _vm.getStoreNames(
                                            scope.row.shopids
                                          ),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .getStoreNames(
                                                  scope.row.shopids
                                                )
                                                .substring(0, 30)
                                            ) + "..."
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getStoreNames(scope.row.shopids)
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            )
                          : scope.row.type === 2
                          ? _c(
                              "span",
                              [
                                _vm.getRegionNames(scope.row.shopids).length >
                                20
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: _vm.getRegionNames(
                                            scope.row.shopids
                                          ),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .getRegionNames(
                                                  scope.row.shopids
                                                )
                                                .substring(0, 30)
                                            ) + "..."
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getRegionNames(scope.row.shopids)
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "enable", label: "启用状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleStatusChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.enable,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "enable", $$v)
                            },
                            expression: "scope.row.enable",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "生效时间", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                scope.row.startTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                scope.row.endTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                scope.row.createTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "更新时间", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                scope.row.updateTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              "page-sizes": [10, 20, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "900px",
            "before-close": _vm.handleDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c("div", { staticClass: "dialog-content" }, [
                _c(
                  "div",
                  { staticClass: "left-panel" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "名称", prop: "name" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { placeholder: "请输入名称" },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "背景图", prop: "imageUrl" } },
                      [
                        _c("div", { staticClass: "image-uploader" }, [
                          _c(
                            "div",
                            {
                              staticClass: "image-preview",
                              on: { click: _vm.triggerSelect },
                            },
                            [
                              _vm.getImageUrl(_vm.formData.imageUrl)
                                ? _c("img", {
                                    staticClass: "preview-img",
                                    attrs: {
                                      src: _vm.getImageUrl(
                                        _vm.formData.imageUrl
                                      ),
                                      alt: "背景图预览",
                                    },
                                  })
                                : _c(
                                    "div",
                                    { staticClass: "image-placeholder" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "placeholder-text" },
                                        [_vm._v("点击上传背景图")]
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "fileInput",
                            staticStyle: { display: "none" },
                            attrs: { type: "file", accept: "image/*" },
                            on: { change: _vm.handleFileChange },
                          }),
                          _vm._v(" "),
                          _vm.formData.imageUrl
                            ? _c(
                                "div",
                                { staticClass: "uploader-actions" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: { click: _vm.removeImage },
                                    },
                                    [_vm._v("移除")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "类型", prop: "type" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择类型" },
                            on: { change: _vm.handleTypeChange },
                            model: {
                              value: _vm.formData.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "type", $$v)
                              },
                              expression: "formData.type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "默认", value: 0 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "门店", value: 1 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "城市", value: 2 },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.formData.type === 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "门店", prop: "shopids" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择门店",
                                  multiple: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.formData.shopids,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "shopids", $$v)
                                  },
                                  expression: "formData.shopids",
                                },
                              },
                              _vm._l(_vm.storeList, function (item) {
                                return _c("el-option", {
                                  key: item.storeId,
                                  attrs: {
                                    label: item.storeName,
                                    value: item.storeId,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm.formData.type === 2
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "城市", prop: "shopids" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择城市",
                                  multiple: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.formData.shopids,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "shopids", $$v)
                                  },
                                  expression: "formData.shopids",
                                },
                              },
                              _vm._l(_vm.regionList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "启用状态", prop: "enable" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                          },
                          model: {
                            value: _vm.formData.enable,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "enable", $$v)
                            },
                            expression: "formData.enable",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "有效时间", prop: "timeRange" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetimerange",
                            "range-separator": "至",
                            "start-placeholder": "开始时间",
                            "end-placeholder": "结束时间",
                          },
                          on: { change: _vm.handleTimeRangeChange },
                          model: {
                            value: _vm.timeRange,
                            callback: function ($$v) {
                              _vm.timeRange = $$v
                            },
                            expression: "timeRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览二维码",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览二维码" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }